export const BiasingSearchView = Backbone.View.extend({
  initialize: function () {
    this.userBiasing = {};

    if (cookieManagement.getCookie('biasingSearchParams') !== null) {
      this.userBiasing = JSON.parse(cookieManagement.getCookie('biasingSearchParams'));
    } else {
      cookieManagement.createCookie('biasingSearchParams', JSON.stringify({}), 30);
    }

    this.listenTo(dispatcher, 'cookie:updateBiasingSearch', this.updateBiasingSearch);
  },
  updateBiasingSearch: function (productCode, addPoints) {
    let points = addPoints;

    if (_.has(this.userBiasing, [productCode])) {
      points = points + this.userBiasing[productCode];
      delete this.userBiasing[productCode];
    }
    this.userBiasing = _.extend({[productCode]: points}, this.userBiasing);

    cookieManagement.createCookie('biasingSearchParams', JSON.stringify(this.userBiasing), 30);

    // -- tracking - top score park code
    const maxValue = _.max(this.userBiasing);
    let idx = 0,
      parkMax = '';
    _.each(this.userBiasing, function (value, key) {
      if (value === maxValue) {
        parkMax = idx === 0 ? key : parkMax + ', ' + key;
        idx++;
      }
    });

    Tracking.dataLayerPush({
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'cookie_scoring',
      gaLabel: parkMax,
      event: 'ABevent'
    });
  }
});